import { MuiAlert, strIsNullOrEmpty } from '@fox/atoms';
import { useContentContext } from '../../content-context';
import { translateDate } from '../../Membership/event-list/filters';
import { DateFilterOptions } from '../../Membership/event-list/util';
import { useEventDetailsPageURL, useEvents } from '../../Membership/query-hooks/query-implementations';
import { DynamicListCarousel } from '../dynamic-lists-carousel';

interface DynamicEventListProps {
	encodedEventPageId: string;
	search?: string;
	location?: string[];
	state?: string[];
	eventDate?: string;
	maxItems?: number;
	defaultThumbnailUrl?: string;
	hideThumbnail?: boolean;
	fadeOutGradientColour?: string;
}
export function DynamicEventList({
	encodedEventPageId,
	eventDate,
	location,
	maxItems,
	search,
	state,
	defaultThumbnailUrl,
	hideThumbnail,
	fadeOutGradientColour
}: DynamicEventListProps) {
	const { requestToken } = useContentContext();
	const { startDate, endDate } = translateDate(!strIsNullOrEmpty(eventDate) ? eventDate : DateFilterOptions.ALL_UPCOMING);

	const { data, error, loading } = useEvents({
		contentId: encodedEventPageId,
		requestToken,
		search,
		startDate,
		endDate,
		page: 0,
		pageSize: maxItems > 0 ? maxItems : 5,
		locations: location,
		states: state
	});

	const {
		data: detailsPageUrl,
		error: detailsPageUrlError,
		loading: detailsPageUrlLoading
	} = useEventDetailsPageURL({ contentId: encodedEventPageId, requestToken });

	if (loading || detailsPageUrlLoading) return <></>;
	if (error || detailsPageUrlError) return <MuiAlert severity="error">{error || detailsPageUrlError}</MuiAlert>;
	if (data?.total === 0) return <MuiAlert severity="info">There are no events to display.</MuiAlert>;

	return (
		<DynamicListCarousel
			fadeOutGradientColour={fadeOutGradientColour}
			items={data?.events?.map((event, i) => {
				return {
					id: i,
					position: i,
					props: { event, hideThumbnail, defaultThumbnailUrl, detailsPageUrl, encodedEventPageId, id: i },
					type: 'events'
				};
			})}
		/>
	);
}
